import { useState, useRef, Fragment } from "react";
import Config from "../../Config";
import MenuTable from "../../helpers/MenuTable";


import back from "../../back.png";
import InputText from "../../helpers/InputText";
import InputTextArea from "../../helpers/InputTextArea";
import InputTime from "../../helpers/InputTime";
import BkTextEditor from "../../BkTextEditor/BkTextEditor";



 

 


function PlanRNew(props)
{

    const [errTab, setErrTab] = useState([]);  //z info od serwera..

       const [emps, setEmps] = useState(null); //pracownicy..

       const [row, setRowX] = useState({
            godzina:  "",         
            godzina_do:  "",         
            opis:  "",         
            tytul:  "",         
        });
        var tmpRow = row;



       


        const [checked, setChecked] = useState(false);
        const handleChange = () => {
            setChecked(!checked);
          };


        const valChecker = (fields) => {

            var allValid = true;
    
                  
            console.log(JSON.stringify(fields) );

            Object.entries(fields).forEach(function(entry) {
    
                var xKey    = entry[0];
                var xValue  = entry[1];                    

                var xValidName = xKey + "_valid";
    
                if(fields[xValidName] == false)
                {
                    allValid = false;
                    console.log("Error field: " + xKey);
                }
                
              });
            
              return allValid;
    
        }
    

        const valChangeListener = (filedName, val, correct, msg) => {         
            //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg); 
       
          
            tmpRow[filedName] = val;
            tmpRow[filedName+"_valid"] = correct;         
            setRowX(  JSON.parse(JSON.stringify(tmpRow)) );            
            //setRowX( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );      
        }   
    
    
        const goNextNew = () => {
            console.log("goNext");
            saveData();
        }
    
        const saveData = () => {


 

            if(!valChecker(row))
            {
                props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , props.userData.dic.dlg_gocorrect  ,  "ok"  ,null); 
                return;
            }
        
    
            props.mainView.setProgress(-2);
    
            var req = row;
    
            fetch( Config.url + '/rest_v1_news,plan_ramowy_n', {
                method: 'POST', 
                body: JSON.stringify(req), 
                headers: {
                    'Content-Type': 'application/json',                    
                    'X-Api-Key': props.userData.apiKey,
                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                    '_sec_key_': Config.genXKey() ,
                }
             })
             .then(res => res.json() )
             .then(res => {             
                        
                        props.mainView.setProgress(-1);
    
                        if(res._sys_ == undefined)
                        {
                            props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                        }else
                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                        {
                           // props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                           setErrTab(res.result);
                        }else
                        if(res.status != undefined && res.status == "OK")
                        {
                            props.mainView.showDialog( "Sukces",  "Pozycja została dodana", "ok" , null);                        
 

                            props.onBack(res.result);
                        }else
                        {
                            props.mainView.showDialog( "Error", "Something is wrong: " + JSON.stringify(res) , "ok" , null);  
                        }
                       
             } )
             .catch(err => {   
                        props.mainView.setProgress(-1);       
                        props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
             });
                       
    
             return false;
    
        }
     


    const onChangeX = (val) => {
            console.log("onChangeX", val  );
          }

    const docValue = [
            {
              children: [
                  {
                    type: 'paragraph' | 'h1' | 'h2' | 'h3',
                    children: [
                      {
                        text: 'A line <br/> of text!',
                      },
                    ],
                  },
                  
                  {
                    type: "h1",
                    children: [{ text: "Heading 1" }],
                  },

                  {
                    type: "h2",
                    children: [{ text: "Heading 2" }],
                  },

                  {
                    type: "paragraph",
                    children: [
                      { text: "Hello World! This is my paragraph inside a sample document." },
                      { text: "Bold text.", bold: true, code: true },
                      { text: "Italic text.", italic: true },
                      { text: "Bold and underlined text.", bold: true, underline: true },
                      { text: "variableFoo", code: true },
                    ],
                  },

                ],
                
            }
          ];
          
    


    return (
        <div className="view_content">
                <img src={back} onClick={props.onBack} className="back_img" title="wstecz"/>

                <form className="eForm bg_center">


                                         


                                            <div className="form_control">
                                                <div className="fieldName">Od godziny*</div>
                                                <InputTime   userData={props.userData} value={row.godzina} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="godzina" placeholder={":"} className='   ' req='1' firstUp="0" />
                                            </div>

                                            <div className="form_control">
                                                <div className="fieldName">Do*</div>
                                                <InputTime   userData={props.userData} value={row.godzina_do} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="godzina_do" placeholder={":"} className='   ' req='1' firstUp="0" />
                                            </div>

                                            <div className="form_split"></div>


                                            <div className="form_control">
                                                <div className="fieldName">Tytuł*</div>
                                                <InputText   userData={props.userData} value={row.tytul} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="tytul" placeholder={"Tytuł:"} className=' w300 ' req='1' firstUp="0" />
                                            </div>


                                            <div className="form_split"></div>

                                            <div className="form_control">
                                                <div className="fieldName">Opis*</div>
                                                <InputTextArea   userData={props.userData} value={row.opis} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="opis" placeholder={"Opis:"} className=' w400  h100' req='1' firstUp="0" />
                                            </div>

                                            {
                                                Config.env == "dev" && 
                                                <BkTextEditor  onChange={onChangeX}  value="...." />
                                            }
                                           

                                          

                                            <div className="form_split"></div>

                                            <div className="form_btn">
                                                    <div className="btn" onClick={saveData}>dodaj</div>
                                                    &nbsp;&nbsp;
                                                    <div className="btn" onClick={props.onBack}    > anuluj</div>
                                            </div>


                </form>

        </div>
    )
}


export default PlanRNew;